import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import EndlessSummer from '../images/endless-summer.svg'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  grid-column: 1 / -1;
  text-align: center;
  color: white;

  h1 {
    font-family: ${props => props.theme.typography.sansSerif};
    font-size: 36px;
    line-height: 40px;
    font-weight: 600;
    color: white;
    text-transform: uppercase;
  }

  a {
    color: white;
    text-decoration: none;
  }

  svg {
    width: 316px;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    h1 {
      font-size: 50px;
      line-height: 50px;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    h1 {
      font-size: 70px;
      line-height: 70px;
    }

    svg {
      width: 720px;
    }
  }
`

const Subtitle = styled.h3`
  margin: 0 auto 12px;
  font-family: ${props => props.theme.typography.sansSerif};
  font-size: 12px;
  line-height: 22px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 20px;
    line-height: 26px;
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    margin-bottom: 28px;
  }
`

const Detail = styled.p`
  margin-top: 12px;
  font-size: 12px;
  line-height: 16px;
  color: inherit;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 20px;
    line-height: 26px;
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    margin-top: 24px;
  }
`

const ReunionHeader = props => (
  <Wrapper {...props}>
    <Link to="/events/artist-reunion/">
      <Subtitle>2021 Artist Reunion</Subtitle>
      <EndlessSummer />
    </Link>
    <Detail>Sep 9 - Sep 11 | San Diego, CA</Detail>
  </Wrapper>
)

export default ReunionHeader
